import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Container,
    PageHeader,
    TitleHead,
    PageWrap,
    Button,
} from "static/coreStyles/global.styled";
import TableHead from "components/TableHead";
import { tableHead } from "./data";
import {
    TableWrap,
    TableHeadWrap,
    TableContentWrap,
} from "static/coreStyles/table.styled";
import { RideList } from "./RideList/RideList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EmptyState from "components/emptyState";
import Pagination from "components/pagination";
import {
    getRideList,
    updateFilters,
    setFilters,
} from "actions/ride";
import { useDebounce } from "utility/helperFunctions";
import { DatePicker, Modal, Select, Slider, Typography } from "antd";
import { CrossTabFilterTag } from "components/CrossTabFilterTag";
import { useSetState } from "utility/helperFunctions";
import { Theme } from "static/coreStyles/theme.styled";
import dayjs from "utils/dateUtils";
import { FilterContainer } from "static/coreStyles/global.styled";
import { Filter } from "static/coreStyles/global.styled";
import { FilterTitle } from "static/coreStyles/global.styled";
import { FilterItem } from "static/coreStyles/global.styled";
import { RIDE_STATUS } from 'utility/constants'
import Search from "components/Search";
import { omit } from "lodash";
import { HeaderButtons } from "components/Header";


const { Option } = Select;
const { RangePicker } = DatePicker;
const { Text } = Typography;


function Rides({
    rideList,
    fetchRideList,
    updateRideFilter,
    setRideFilter,
    filters,
    pagination,
}) {
    const sortMap = filters.sort || {};
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, 800);
    const [modalVisible, setModalVisible] = useState(false);
    const dispatch = useDispatch();
    const isDrillDownFilter = Boolean(filters.groupId);


    useEffect(() => {
        if (isDrillDownFilter) return;
        if (debouncedSearchTerm) {
            updateRideFilter({
                query: debouncedSearchTerm,
            });
        } else {
            updateRideFilter({
                query: "",
            });
        }
    }, [debouncedSearchTerm, isDrillDownFilter]);

    useEffect(() => {
        if (filters.groupId) {
            setSearchTerm("");
            if (filters.query) {
                updateRideFilter({ query: "" });
            }
        }
    }, [filters.groupId]);

    const handleSort = (key, value) => {
        if (value === "") {
            const sortKeys = omit(filters.sort, key);
            updateRideFilter({
                sort: sortKeys,
            });
        } else {
            updateRideFilter({
                sort: {
                    ...(filters.sort ? filters.sort : {}),
                    [key]: value,
                },
            });
        }
    };

    const handleRemoveGroupFilter = () => {
        const newFilters = {
            ...filters,
            page: 0,
            sort: {
                startDateTime: "desc"
            }
        };
        delete newFilters.groupId;
        delete newFilters.groupName;
        dispatch(setFilters(newFilters));
    };

    useEffect(() => {
        fetchRideList(filters);
    }, [filters]);

    return (
        <PageWrap>
            <Container>
                <PageHeader>
                    <TitleHead>
                        <Search
                            setSearchTerm={setSearchTerm}
                            onFilterClick={() => {
                                setModalVisible(true);
                            }}
                            filters={filters}
                            setFilter={setRideFilter}
                            filterDisabled={isDrillDownFilter}
                            searchDisabled={isDrillDownFilter}
                        />

                        <HeaderButtons />
                    </TitleHead>
                </PageHeader>

                {filters.groupId && (
                    <CrossTabFilterTag
                        label="Group"
                        value={filters.groupName || filters.groupId}
                        onClose={handleRemoveGroupFilter}
                    />
                )}

                {/* Rides List */}
                {rideList && rideList.length > 0 ? (
                    <div>
                        <TableWrap>
                            <TableHeadWrap>
                                {tableHead.map((item, index) => {
                                    const sortingKey =
                                        item.sortKey &&
                                            sortMap &&
                                            sortMap.hasOwnProperty(item.sortKey)
                                            ? sortMap[item.sortKey]
                                            : null;
                                    return (
                                        <TableHead
                                            data={item}
                                            key={index}
                                            isSorted={!!item.sortKey && !isDrillDownFilter}
                                            handleSort={() => {
                                                if (sortingKey === "desc") {
                                                    handleSort(item.sortKey, "asc");
                                                } else if (sortingKey === "asc") {
                                                    handleSort(item.sortKey, "");
                                                } else {
                                                    handleSort(item.sortKey, "desc");
                                                }
                                            }}
                                            sort={sortingKey}
                                        />
                                    );
                                })}
                            </TableHeadWrap>
                            <TableContentWrap>
                                {rideList.map((item, index) => {
                                    return <RideList data={item} key={index} />;
                                })}
                            </TableContentWrap>
                        </TableWrap>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <Text type="secondary">
                            {filters.groupId ?
                                `No rides found for group "${filters.groupName}"` :
                                'No rides found'
                            }
                        </Text>
                    </div>
                )}

                <Pagination
                    page={filters.page}
                    pagination={pagination}
                    updatePage={(newPage) => {
                        updateRideFilter({ page: newPage });
                    }}
                />

                <FilterModal
                    filters={filters}
                    open={modalVisible}
                    setVisible={setModalVisible}
                    setFilter={setRideFilter}
                    updateFilter={updateRideFilter}
                />
            </Container>
        </PageWrap>
    );
}

function FilterModal({ open, setVisible, setFilter }) {
    const [state, setState] = useSetState({});
    return (
        <Modal
            title="Apply Filter"
            open={open}
            styles={{
                body: {
                    padding: "24px",
                    borderTop: "1px solid #f0f0f0",
                    borderBottom: "1px solid #f0f0f0",
                },
                footer: {
                    padding: "8px 0 0 0",   
                    marginTop: 0,
                },
            }}
            onCancel={() => setVisible(false)}
            footer={[
                <Button
                    key="reset"
                    onClick={() => {
                        setFilter(null);
                        setState({
                            dateRange: null,
                            rideStatus: "",
                            memberRange: null,
                            riderRange: null,
                        });
                        setVisible(false);
                    }}
                >
                    Reset
                </Button>,
                <Button
                    key="submit"
                    primary
                    color={Theme.blueColor}
                    onClick={() => {
                        const { dateRange, rideStatus, memberRange, riderRange } = state;
                        const filterData = {};
                        if (dateRange) {
                            if (dateRange[0]) {
                                filterData["rideAfter"] = dayjs(dateRange[0])
                                    .format("YYYY-MM-DD")
                                    .toString();
                            }
                            if (dateRange[1]) {
                                filterData["rideBefore"] = dayjs(dateRange[1])
                                    .format("YYYY-MM-DD")
                                    .toString();
                            }
                        }

                        if (memberRange) {
                            filterData["memberRange"] = `${memberRange[0]}-${memberRange[1]}`;
                        }

                        if (riderRange) {
                            filterData["riderRange"] = `${riderRange[0]}-${riderRange[1]}`;
                        }

                        if (rideStatus) {
                            filterData["rideStatus"] = rideStatus;
                        }

                        setFilter(filterData);
                        setVisible(false);
                    }}
                >
                    Apply
                </Button>,
            ]}
        >
            <FilterContainer>
                <Filter>
                    <FilterTitle>Ride Date</FilterTitle>
                    <FilterItem>
                        <RangePicker
                            allowEmpty={[true, true]}
                            value={state.dateRange}
                            onChange={(value) => {
                                setState({
                                    dateRange: value,
                                });
                            }}
                        />
                    </FilterItem>
                </Filter>
                <Filter>
                    <FilterTitle>Ride Status</FilterTitle>
                    <FilterItem>
                        <Select
                            value={state.rideStatus}
                            allowClear
                            style={{ flex: 1 }}
                            placeholder="Select Ride Status"
                            onChange={(value) => {
                                setState({
                                    rideStatus: value,
                                });
                            }}
                        >
                            {RIDE_STATUS.map((item) => {
                                return <Option key={item} value={item}>{item}</Option>;
                            })}
                        </Select>
                    </FilterItem>
                </Filter>
                <Filter>
                    <FilterTitle>Member Range</FilterTitle>
                    <FilterItem>
                        <Slider
                            style={{ flex: 1 }}
                            step={1}
                            min={0}
                            max={100}
                            tooltipPlacement="bottomLeft"
                            range
                            value={state.memberRange}
                            onChange={(value) => {
                                setState({
                                    memberRange: value,
                                });
                            }}
                        />
                    </FilterItem>
                </Filter>
                <Filter>
                    <FilterTitle>Rider Range</FilterTitle>
                    <FilterItem>
                        <Slider
                            style={{ flex: 1 }}
                            step={1}
                            min={0}
                            max={20}
                            tooltipPlacement="bottomLeft"
                            range
                            value={state.riderRange}
                            onChange={(value) => {
                                setState({
                                    riderRange: value,
                                });
                            }}
                        />
                    </FilterItem>
                </Filter>

            </FilterContainer>
        </Modal>
    );
}

function mapStateToProps(state) {
    const {
        Ride: { rideList, filters, pagination },
    } = state;
    return {
        rideList,
        pagination,
        filters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchRideList: bindActionCreators(getRideList, dispatch),
        setRideFilter: bindActionCreators(setFilters, dispatch),
        updateRideFilter: bindActionCreators(updateFilters, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Rides);
